export const DEFAULT_SEO = {
  title: "QT Foods | Wholesale Japanese Tea Supplier & Bulk Matcha",
  description:
    "B2B wholesale Japanese tea supplier. Direct from Japan sourcing for bulk matcha powder, wholesale hojicha, sencha, and private label solutions.",
  image: "https://www.qtfoods.co.jp/assets/images/journal/typologies.png",
  url: "https://www.qtfoods.co.jp",
  siteName: "QT Foods",
};

interface SeoProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

function toAbsoluteUrl(pathOrUrl: string, baseUrl = "https://www.qtfoods.co.jp"): string {
  if (!pathOrUrl) return pathOrUrl;
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) {
    return pathOrUrl;
  }
  return `${baseUrl}${pathOrUrl.startsWith("/") ? "" : "/"}${pathOrUrl}`;
}

function getImageType(url: string): string {
  if (url.endsWith(".png")) return "image/png";
  if (url.endsWith(".jpg") || url.endsWith(".jpeg")) return "image/jpeg";
  if (url.endsWith(".webp")) return "image/webp";
  if (url.endsWith(".svg")) return "image/svg+xml";
  return "image/png";
}

/**
 * Centralized SEO registry generating tags to avoid duplicate metadata
 * Single Source of Truth for social media previews.
 */
export function seo({
  title = DEFAULT_SEO.title,
  description = DEFAULT_SEO.description,
  image = DEFAULT_SEO.image,
  url = DEFAULT_SEO.url,
}: SeoProps = {}) {
  const fullImage = toAbsoluteUrl(image);
  const fullUrl = url ? toAbsoluteUrl(url) : undefined;
  const imageType = getImageType(fullImage);

  const tags = [
    { title },
    { name: "description", content: description },
    { property: "og:type", content: "website" },
    { property: "og:site_name", content: DEFAULT_SEO.siteName },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:image", content: fullImage },
    { property: "og:image:secure_url", content: fullImage },
    { property: "og:image:type", content: imageType },
    { property: "og:image:width", content: "1024" },
    { property: "og:image:height", content: "1024" },
    { property: "og:image:alt", content: title },
    { property: "og:locale", content: "en_US" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: fullImage },
  ];

  if (fullUrl) {
    tags.push({ property: "og:url", content: fullUrl });
  }

  return tags;
}
